/**
 * "Premium" state (ad-free) — localStorage + subscribers.
 * The final truth is Google Play (restorePurchases on startup on Android);
 * localStorage only avoids ad flickers before the restore.
 */

const STORAGE_KEY = "premium.v1";

type Listener = (premium: boolean) => void;

interface PremiumStore {
  isPremium: () => boolean;
  setPremium: (value: boolean) => void;
  subscribe: (listener: Listener) => () => void;
}

export function createPremiumStore(storage?: Pick<Storage, "getItem" | "setItem">): PremiumStore {
  const backend = storage ?? (typeof localStorage === "undefined" ? null : localStorage);
  let premium = false;
  try {
    premium = backend?.getItem(STORAGE_KEY) === "true";
  } catch {
    premium = false;
  }
  const listeners = new Set<Listener>();

  return {
    isPremium: () => premium,
    setPremium: (value) => {
      if (value === premium) {
        return;
      }
      premium = value;
      try {
        backend?.setItem(STORAGE_KEY, String(value));
      } catch {
        // storage blocked: the state lives in memory
      }
      for (const listener of listeners) {
        listener(value);
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
